import { Component } from '@angular/core';

@Component({
  selector: 'app-auth-layout',
  templateUrl: './auth-layout.component.html',
})
export class AuthLayoutComponent {
  /**
   * @description
   * This component just hold router-outlet for auht pages (login, reset pass)
   */
}
